import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import PatientMiniProfile from './PatientMiniProfile';

loadDOMComponent({
	selector: 'react-patient-mini-profile',
	callback: ({ container }) => {
		const userId = container.getAttribute('userId');
		const workplaceId = container.getAttribute('workplaceId');
		const loggedUserId = container.getAttribute('loggedUserId');
		const showVerifyInformation =
			container.getAttribute('showVerifyInformation') === 'true';
		const showBirthDate = container.getAttribute('showBirthDate') === 'true';
		const showAge = container.getAttribute('showAge') === 'true';
		const showAddress = container.getAttribute('showAddress') === 'true';
		const showPhone = container.getAttribute('showPhone') === 'true';
		const showEmail = container.getAttribute('showEmail') === 'true';
		const showInsuranceCompany =
			container.getAttribute('showInsuranceCompany') === 'true';
		const showGender = container.getAttribute('showGender') === 'true';

		const links = {
			verifyInsurance: container.getAttribute('linkVerifyInsurace') || null,
			verifyAddress: container.getAttribute('linkVerifyAddress') || null,
			openUserProfile: container.getAttribute('openUserProfile') || null,
		};

		ReactDOM.render(
			<AppContextProvider>
				<PatientMiniProfile
					userId={userId}
					workplaceId={workplaceId}
					loggedUserId={loggedUserId}
					showVerifyInformation={showVerifyInformation}
					links={links}
					showBirthDate={showBirthDate}
					showAge={showAge}
					showEmail={showEmail}
					showPhone={showPhone}
					showAddress={showAddress}
					showInsuranceCompany={showInsuranceCompany}
					showGender={showGender}
				/>
			</AppContextProvider>,
			container,
		);
	},
});
